import clsx from 'clsx';
import React from 'react';

import Icon, { ICONS, ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';
import { ACTION_POSITIONS, MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import useConfirmPopup from '@/src/components/common/Elements/Modal/useConfirmPopup';

import ActionButton from '../../Elements/ActionButton/ActionButton';

type AutomationButtonProps = {
  disabled: boolean;
  isMultiPagePdf: boolean;
  onClickAutomate: () => void;
};

const AutomationButton = ({ disabled, isMultiPagePdf, onClickAutomate }: AutomationButtonProps) => {
  const automateIcon = disabled
    ? ICONS.automation_off({ fill: '#999999' })
    : ICONS.automation_on({
        strokeClasses:
          'tw-stroke-cfo-purple-200 group-hover:tw-fill-white group-hover:tw-stroke-white',
        width: '16',
        height: '16',
      });

  const [ConfirmMultiplePagedFileModal, confirmMultiplePagedFile] = useConfirmPopup({
    classNames: '',
    modalWidth: '600px',
    actionPosition: ACTION_POSITIONS.end,
    title: 'Is this  single transaction?',
    message: `This file contains multiple pages. We are currently able to process files with single-entry transaction only.  Do you wish to proceed?`,
    cancelBtn: true,
    confirmBtn: {
      label: 'Yes, please proceed.',
    },
    icon: { icon: ICONS.info, iconType: ICON_TYPES.outlined, className: 'tw-text-cfo-blue-600' },
    modalType: { ...MODAL_TYPE.default, headerTextClasses: 'tw-text-cfo-blue-600' },
  });

  const handleClickAutomate = async () => {
    if (isMultiPagePdf) {
      if (!(await confirmMultiplePagedFile())) return;
    }
    onClickAutomate();
  };

  return (
    <React.Fragment>
      <ActionButton
        id={'automate'}
        className={clsx(
          'tw-group',
          '!tw-mr-0 tw-ml-[10px] !tw-px-[10px] !tw-py-[3px] ',
          !disabled &&
            'tw-text-cfo-purple-200 tw-bg-white tw-border-cfo-purple-200 hover:tw-bg-cfo-purple-200 hover:tw-text-white'
        )}
        disabled={disabled}
        tooltipSettings={{
          className: clsx('tw-font-brandonTextRegular', 'tw-max-w-[305px] tw-w-full'),
          content: disabled ? (
            <span className={clsx('tw-flex tw-items-start tw-justify-start tw-text-left ')}>
              <Icon
                className={clsx('tw-text-[20px] tw-mr-[5px]', '!tw-text-white')}
                icon={ICONS.info}
                iconType={ICON_TYPES.outlined}
              />
              Unable to perform action.
              <br /> Please contact your system administrator.
            </span>
          ) : null,
          place: 'bottom-end',
        }}
        onClick={handleClickAutomate}
      >
        <Icon
          icon={automateIcon}
          iconType={ICON_TYPES.rounded}
          className={clsx('tw-text-[15px] tw-mr-[5px]')}
        />
        Automate
      </ActionButton>

      <ConfirmMultiplePagedFileModal />
    </React.Fragment>
  );
};

export default AutomationButton;
